import { useMemo } from 'react';
import { gridConfigs } from '../constants/gridConfigs';
import { generateColumnsDefaultConfiguration } from '../../../components/dataGrid/columnHelpers';

export const useGetColumns = ({ filters, tipoRemitoId, tipoAutorizacionId }) => {

    const columns = useMemo(() => {
        if (!filters || !filters.tipoReporte) return;
        
        let selectedColumns;
        if (filters.tipoReporte === tipoRemitoId) {
            selectedColumns = gridConfigs.REMITO.columns;
        } else if (filters.tipoReporte === tipoAutorizacionId) {
            selectedColumns = gridConfigs.AUTORIZACION.columns;
        } else {
            selectedColumns = gridConfigs.DEFAULT.columns;
        }
        return generateColumnsDefaultConfiguration(selectedColumns, true);
    }, [filters]);

    return columns;
}